module.exports = __webpack_public_path__ + "assets/98acac879ace9ec3e6a12b91f60afc5e.svg";